<template>
 <Head>
    <title> Edit Skill | {{$page.props.appName}}</title>
    <meta name="description" :content="'Edit Skill ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
      <form @submit.prevent="false">
       

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Skill Name:</label>
            <input v-model="this.form.skill_name" type="text" class="form-input" />
          </div>
<div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Skill Group:</label>
            <select name="" id="" v-model="this.form.skill_group_id" class="form-select">
              <option :value="skillgroup.id" v-for="skillgroup in skillgroups" :key="skillgroup.id">
                {{skillgroup.skill_group_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="w-full">
             <button class="bg-red-400 text-white font-bold p-2 ml-6 mt-3 float-left" @click="deletedata()" >DELETE SKILL </button>
            <button type="submit" class="bg-black text-white font-bold p-2 mr-6 mt-3 float-right" :disabled="form.processing" @click="store()">EDIT SKILL </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  props : {
      'skill' : Object,
      'id' : String,
      'skillgroups' : Object
  },
  layout: Layout,
  components: { Link, Pagination,Head },
  data() {
    return {
      url: "",
      form: this.$inertia.form({
        skill_name: this.skill.skill_name,
        skill_group_id: this.skill.skill_group_id,

      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/skill/edit/" + this.id);
    },
    deletedata() {
        if(confirm("Are you sure you want to delete this skill?")){
            this.$inertia.delete("/admin/skill/edit/" + this.id)
        }
    }
  },
};
</script>
     